var _style, _g, _path, _g2, _g3, _path2, _g4, _defs, _path3, _g5, _g6, _path4, _g7, _g8, _g9;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgZohoExport = function SvgZohoExport(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.zohoStyle0{fill:#E79224;}\r\n\t.zohoStyle1{fill:url(#SVGID_1_);}\r\n\t.zohoStyle2{fill:#FEF26F;}\r\n\t.zohoStyle3{fill:#91C9ED;}\r\n\t.zohoStyle4{fill:url(#SVGID_2_);}\r\n\t.zohoStyle5{fill:#0B9AD6;}\r\n\t.zohoStyle6{clip-path:url(#SVGID_3_);}\r\n\t.zohoStyle7{fill:url(#SVGID_4_);}\r\n\t.zohoStyle8{fill:#98D0A0;}\r\n\t.zohoStyle9{fill:#68BF6B;}\r\n\t.zohoStyle10{fill:url(#SVGID_5_);}\r\n\t.zohoStyle11{fill:#EF463D;}\r\n\t.zohoStyle12{fill:#761116;}\r\n\t.zohoStyle13{fill:#FFFFFF;}\r\n")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333 0 0 -1.3333 0 100.08)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.29378 0 0 .29378 0 .042373)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(740.38 200.84)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "zohoStyle0 disabledStyle",
    d: "M-494.6-44.6v-56.3l-7.8-7.6v55L-494.6-44.6"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 2.8912,
    y1: 4.1319,
    x2: 3.2116,
    y2: 4.1319,
    gradientTransform: "matrix(-2.741878e-06 -64.3558 -64.3558 2.741878e-06 478.355 332.667)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE500"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FCB822"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "zohoStyle1 disabledStyle",
    d: "M238.2,147.4h-51.5V92.3h51.5V147.4z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(581.1 200.72)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "zohoStyle2 disabledStyle",
    d: "M-386.3-44.6l-8.1-8.8h51.5l7.6,8.8L-386.3-44.6"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(382.23 193.19)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "zohoStyle3 disabledStyle",
    d: "M-251.2-39.5l50.6,7l-4.2-12.1l-48-7.6l0.2,8.7L-251.2-39.5"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.1995,
    y1: -0.4452,
    x2: 0.52,
    y2: -0.4452,
    gradientTransform: "matrix(63.0945 -50.6699 -50.6699 -63.0945 95.2037 123.0534)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#168CCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00649E"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "zohoStyle4 disabledStyle",
    d: "M177.4,148.6l7-49.4l-49.9-7l-6.7,47.7l2.9,2.3L177.4,148.6"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(540.18 215.15)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "zohoStyle5 disabledStyle",
    d: "M-358.5-54.4l0-0.3l6.6-50.5l-3.8-10.7l-7,49.4"
  }))), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polyline", {
    id: "SVGID_9_",
    points: "88.3,158 133.1,137.7 112.9,91.8 68.1,112 88.3,158  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_3_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_9_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "zohoStyle6"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 2.6751,
    y1: 0.3902,
    x2: 2.9955,
    y2: 0.3902,
    gradientTransform: "matrix(-2.350181e-06 -56.3808 -56.3808 2.350181e-06 149.1865 290.407)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#25A149"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#008A52"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "zohoStyle7 disabledStyle",
    d: "M8.6,173.7h237.3V91.8H8.6V173.7z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(234.31 255.36)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "zohoStyle8 disabledStyle",
    d: "M-150.7-81.7l4.7-15.7l44.8-20.2l-3.8,15L-150.7-81.7"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(234.31 255.36)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "zohoStyle9 disabledStyle",
    d: "M-150.7-81.7l-18-42.8l2.5-18.8l20.2,45.9L-150.7-81.7"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 2.6964,
    y1: -1.6617,
    x2: 3.0169,
    y2: -1.6617,
    gradientTransform: "matrix(9.6961 -58.5352 -58.5352 -9.6961 -89.7423 285.8249)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D92231"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BA2234"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "zohoStyle10 disabledStyle",
    d: "M58.6,148.7l7.4-48.6l-49.5-7.8l-8,48.7L58.6,148.7"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 153.57)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "zohoStyle11 disabledStyle",
    d: "M8.6-12.5L12,4.8l50,8L58.6-4.9L8.6-12.5"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(166.88 232.7)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "zohoStyle12 disabledStyle",
    d: "M-104.8-66.3l7.3-49l-3.3-17.2l-7.4,48.6L-104.8-66.3"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(500.47 147.76)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "zohoStyle13",
    d: "M-331.5-8.6c-0.2,1.5-0.7,2.7-1.6,3.5c-0.7,0.6-1.5,0.9-2.5,0.9c-0.2,0-0.5,0-0.8-0.1 c-1.3-0.2-2.3-0.8-2.9-1.8c-0.4-0.7-0.7-1.6-0.7-2.6c0-0.4,0-0.8,0.1-1.2l1.8-12.8l-14.4-2.1l-1.8,12.8c-0.2,1.5-0.7,2.7-1.6,3.4 c-0.7,0.6-1.5,1-2.5,1c-0.2,0-0.5,0-0.7-0.1c-1.4-0.2-2.4-0.8-3-1.8c-0.5-0.7-0.7-1.6-0.7-2.6c0-0.4,0-0.8,0.1-1.2l4.9-33.4 c0.2-1.5,0.8-2.7,1.6-3.5c0.7-0.6,1.6-0.9,2.5-0.9c0.3,0,0.6,0,0.8,0.1c1.2,0.2,2.2,0.8,2.8,1.8c0.4,0.7,0.6,1.5,0.6,2.5 c0,0.4,0,0.8-0.1,1.2l-2,13.2l14.4,2.1l2-13.2c0.2-1.5,0.8-2.7,1.6-3.4c0.7-0.6,1.5-0.9,2.5-0.9c0.2,0,0.5,0,0.8,0.1 c1.3,0.2,2.3,0.8,2.9,1.8c0.4,0.7,0.6,1.6,0.6,2.5c0,0.4,0,0.8-0.1,1.2L-331.5-8.6z M-389.9-27.1c-1.7-4-3.9-6.7-6.7-8.2 c-1.5-0.8-3-1.2-4.6-1.2c-1.4,0-2.8,0.3-4.2,0.9c-3.1,1.3-5.1,3.5-5.9,6.5c-0.3,1-0.4,2.1-0.4,3.2c0,2.2,0.6,4.7,1.7,7.3 c1.7,4.1,4,6.8,6.7,8.4c1.5,0.8,3,1.2,4.6,1.2c1.4,0,2.8-0.3,4.3-0.9c3.1-1.3,5.1-3.5,5.9-6.5c0.3-1,0.4-2,0.4-3.1 C-388.2-21.8-388.7-24.3-389.9-27.1z M-385-7.1c-1.8,1.9-3.9,3.3-6.4,4.4c-2.5,1.1-5,1.6-7.5,1.6l-0.1,0c-2.6,0-5.1-0.6-7.6-1.7 v0c-2.6-1.1-4.9-2.7-6.9-4.8c-1.9-2.1-3.5-4.5-4.7-7.4c-1.2-2.8-1.9-5.7-2-8.5c0-0.3,0-0.6,0-1c0-2.5,0.4-5,1.3-7.4 c0.9-2.5,2.3-4.7,4-6.6c1.8-1.9,4-3.3,6.5-4.4v0c2.5-1,5-1.6,7.5-1.6h0.1c2.6,0,5.1,0.6,7.6,1.6l0,0l0,0c2.6,1.2,4.9,2.8,6.9,4.9 c2,2.1,3.6,4.5,4.8,7.4c1.2,2.9,1.9,5.7,2,8.5c0,0.3,0,0.5,0,0.8c0,2.5-0.4,5-1.4,7.5C-381.9-11.1-383.2-8.9-385-7.1z  M-447.1-39.9c-0.4,0.5-0.9,0.8-1.6,1c-0.7,0.2-1.5,0.3-2.4,0.3c-0.9,0-1.9-0.1-3-0.3l-13.1-2.2c0.1,1,0.6,2.3,1.5,3.9 c1,1.8,2.4,4,4.4,6.5l0,0c0.7,0.9,1.2,1.6,1.5,2c0.2,0.3,0.6,0.8,1,1.4c3,3.9,4.8,7.1,5.6,9.6c0.4,1.4,0.7,2.9,0.7,4.3 c0,0.4,0,0.8,0,1.2c0,1-0.1,2.1-0.3,3.1c-0.2,0.9-0.4,1.7-0.7,2.3c-0.3,0.6-0.7,1.1-1.2,1.4c-0.5,0.3-1.3,0.5-2.3,0.5 c-0.8,0-1.8-0.1-2.9-0.3l-15.1-2.6c-1.8-0.3-3.2-0.9-4-1.7c-0.7-0.6-1-1.5-1-2.4c0-0.2,0-0.5,0.1-0.8c0.2-1.3,0.9-2.2,2-2.7 c0.6-0.3,1.4-0.4,2.3-0.4c0.6,0,1.3,0.1,2,0.2l12.6,2.1c0-0.2,0-0.4,0-0.7c0-0.8-0.1-1.6-0.4-2.3c-0.4-1-1.3-2.5-2.8-4.4 c-0.4-0.5-1.1-1.3-1.9-2.4c-3.4-4.1-5.9-7.7-7.3-10.6c0,0,0,0,0,0c0,0,0,0,0,0c-1-2-1.8-4-2.2-6c-0.2-1.1-0.4-2.2-0.4-3.3 c0-0.8,0.1-1.5,0.2-2.2c0.2-1,0.4-1.8,0.8-2.5c0.3-0.7,0.8-1.1,1.3-1.4c0.5-0.3,1.2-0.4,2.2-0.4c1.3,0,3,0.2,5.1,0.6l13.7,2.3 c2.4,0.4,4.1,1,5.1,1.8c0.8,0.6,1.2,1.5,1.2,2.6c0,0.3,0,0.5-0.1,0.8C-446.5-40.9-446.8-40.4-447.1-39.9L-447.1-39.9z  M-458.8-27.2L-458.8-27.2C-458.8-27.2-458.8-27.2-458.8-27.2L-458.8-27.2L-458.8-27.2z M-280.7-38.4c-2-2.4-4.6-3.6-8.1-3.6 c-3.5,0-6.1,1.2-8.1,3.6c-2,2.4-3,5.6-3,9.8c0,4.3,1,7.6,3,10c2,2.4,4.6,3.6,8.1,3.6c3.4,0,6.1-1.2,8.1-3.6c2-2.4,3-5.7,3-10 C-277.8-32.7-278.8-36-280.7-38.4z M-270.1-20.2c-1,2.6-2.5,4.9-4.5,6.9c-1.9,1.9-4.1,3.4-6.4,4.4c-2.4,1-4.9,1.5-7.7,1.5 c-2.8,0-5.4-0.5-7.7-1.5c-2.4-1-4.5-2.5-6.4-4.4c-2-2-3.5-4.3-4.5-6.8c-1-2.6-1.5-5.4-1.5-8.4c0-3,0.5-5.8,1.5-8.3 c1-2.6,2.5-4.9,4.5-6.9c1.8-1.9,4-3.4,6.3-4.3c2.4-1,5-1.5,7.8-1.5c2.7,0,5.3,0.5,7.7,1.5c2.4,1,4.5,2.4,6.4,4.3 c2,2,3.5,4.4,4.5,6.9c1,2.6,1.5,5.4,1.5,8.4S-269.1-22.8-270.1-20.2"
  }))))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgZohoExport, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/zoho_export.920c012d.svg";
export { ForwardRef as ReactComponent };